/* eslint-disable no-undef */
document.addEventListener('DOMContentLoaded', function() {
  // burger menu
  const menuOpener = document.querySelector('.js-gr-menu-opener');
  const menu = document.querySelector('.js-gr-menu');
  const menuInner = document.querySelector('.js-gr-menu__inner');
  if (menuOpener) {
    menuOpener.addEventListener('click', toggleMenu);
    document.addEventListener('click', function(e) {
      const target = e.target;
      if (!target.closest('.js-gr-menu')) {
        closeMenu();
      }
    });
  }
  
  function toggleMenu() {
    menuOpener.classList.toggle('active');
    menu.classList.toggle('active');
    menuInner.classList.toggle('active');
  }
  
  function closeMenu() {
    menuOpener.classList.remove('active');
    menu.classList.remove('active');
    menuInner.classList.remove('active');
  }
});
